import { Marker } from 'react-map-gl/maplibre'

interface DeviceMarkerProps {
  lat: number
  lon: number
  isOnline: boolean
}

const markerStyles = `
@keyframes marker-pulse {
  0% { transform: scale(1); opacity: 0.6; }
  100% { transform: scale(2.4); opacity: 0; }
}
.maplibregl-marker {
  position: absolute !important;
  top: 0;
  left: 0;
  will-change: transform;
  cursor: pointer;
  z-index: 3;
}
.maplibregl-canvas-container {
  position: relative;
}
`

export default function DeviceMarker({ lat, lon, isOnline }: DeviceMarkerProps) {
  return (
    <>
      <style>{markerStyles}</style>
      <Marker longitude={lon} latitude={lat} anchor="center">
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {/* Pulse ring for online devices */}
          {isOnline && (
            <div
              style={{
                position: 'absolute',
                width: 40,
                height: 40,
                borderRadius: '50%',
                background: '#6366f1',
                animation: 'marker-pulse 2s cubic-bezier(0, 0, 0.2, 1) infinite',
              }}
            />
          )}
          {/* Outer shadow ring */}
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              background: '#6366f1',
              boxShadow: '0 4px 12px rgba(99, 102, 241, 0.4)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
            }}
          >
            {/* Inner white pin icon */}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
                fill="#ffffff"
              />
            </svg>
          </div>
        </div>
      </Marker>
    </>
  )
}
